import React from "react";
import { wrapCollectionLayout } from "@quintype/components";

import SliderFocusedCard from "../rows/SliderFocusedCard";
import NineStories from "../rows/NineStories";
import FiveOpinionStories from "../rows/FiveOpinionStories";
import FourStories from "../rows/FourStories";
import FourteenStories3Ad1Widget from "../rows/FourteenStories3Ad1Widget";
import PhotoStoryWithSlider from "../rows/PhotoStoryWithSlider";
import FourCollection12Stories1Ad from "../rows/FourCollection12Stories1Ad";
import SixStories1AdWithTagSearch from "../rows/SixStories1AdWithTagSearch";
import SixStories1WidgetWithPoll from "../rows/SixStories1WidgetWithPoll";
import FourCollection12Stories from "../rows/FourCollection12Stories";
import TenStories2AdWithLoadMore from "../rows/TenStories2AdWithLoadMore";
import Stories2AdWithLoadMore from "../rows/Stories2AdWithLoadMore";
import SixteenStories3AdWithTagSearchAndLoadMore from "../rows/SixteenStories3AdWithTagSearchAndLoadMore";
import SixteenStories1WidgetWithPollAndLoadMore from "../rows/SixteenStories1WidgetWithPollAndLoadMore";
import FiveVideoStories from "../rows/FiveVideoStories";
import BigPhotoStoryCardSlider1Ad from "../rows/BigPhotoStoryCardSlider1Ad";
import BigVideoStoryCard2Ad from "../rows/BigVideoStoryCard2Ad";
import FourColStoriesWithLoadMore from "../rows/FourColStoriesWithLoadMore";
import FourStoryCards from "../rows/FourStoryCards";
import OneColThreeStoriesSlider from "../rows/OneColThreeStoriesSlider";
import WidgetOrAdvertisement from "../rows/WidgetOrAdvertisement";
import MultipurposeComponent from "../rows/MultipurposeComponent";
import FiveStories1AdWithWidget from "../rows/FiveStories1AdWithWidget";
import NumberedNewsCard from "../rows/NumberedNewsCard";
import Numbered5Stories from "../rows/Numbered5Stories";
import FullScreenFeatured from "../rows/FullScreenFeatured";
import TinyFourNewsCard from "../rows/TinyFourNewsCard";
import VisualStories from "../rows/VisualStories";
import NumberedSliderStories from "../rows/NumberedSliderStories";
import OneSpecialStory3Related from "../rows/OneSpecialStory3Related";
import NewsHeadlineTicker from "../rows/NewsHeadlineTicker";
import TenNumberedStories from "../rows/TenNumberedStories";

function wrapEager(f) {
  const wrappedComponent = function WrapEager(props) {
    return React.createElement(f, props);
  };

  if (f.storyLimit) {
    wrappedComponent.storyLimit = f.storyLimit;
  }

  if (f.nestedCollectionLimit) {
    wrappedComponent.nestedCollectionLimit = f.nestedCollectionLimit;
  }

  return wrappedComponent;
}

export default {
  SliderFocusedCard: wrapEager(wrapCollectionLayout(SliderFocusedCard)),
  NineStories: wrapEager(wrapCollectionLayout(NineStories)),
  FiveOpinionStories: wrapEager(wrapCollectionLayout(FiveOpinionStories)),
  FourStories: wrapEager(wrapCollectionLayout(FourStories)),
  FourteenStories3Ad1Widget: wrapEager(wrapCollectionLayout(FourteenStories3Ad1Widget)),
  PhotoStoryWithSlider: wrapEager(wrapCollectionLayout(PhotoStoryWithSlider)),
  FourCollection12Stories1Ad: wrapEager(wrapCollectionLayout(FourCollection12Stories1Ad)),
  SixStories1AdWithTagSearch: wrapEager(wrapCollectionLayout(SixStories1AdWithTagSearch)),
  SixStories1WidgetWithPoll: wrapEager(wrapCollectionLayout(SixStories1WidgetWithPoll)),
  FourCollection12Stories: wrapEager(wrapCollectionLayout(FourCollection12Stories)),
  TenStories2AdWithLoadMore: wrapEager(wrapCollectionLayout(TenStories2AdWithLoadMore)),
  Stories2AdWithLoadMore: wrapEager(wrapCollectionLayout(Stories2AdWithLoadMore)),
  FiveVideoStories: wrapEager(wrapCollectionLayout(FiveVideoStories)),
  FourStoryCards: wrapEager(wrapCollectionLayout(FourStoryCards)),
  BigPhotoStoryCardSlider1Ad: wrapEager(wrapCollectionLayout(BigPhotoStoryCardSlider1Ad)),
  BigVideoStoryCard2Ad: wrapEager(wrapCollectionLayout(BigVideoStoryCard2Ad)),
  FourColStoriesWithLoadMore: wrapEager(wrapCollectionLayout(FourColStoriesWithLoadMore)),
  SixteenStories3AdWithTagSearchAndLoadMore: wrapEager(wrapCollectionLayout(SixteenStories3AdWithTagSearchAndLoadMore)),
  SixteenStories1WidgetWithPollAndLoadMore: wrapEager(wrapCollectionLayout(SixteenStories1WidgetWithPollAndLoadMore)),
  OneColThreeStoriesSlider: wrapEager(wrapCollectionLayout(OneColThreeStoriesSlider)),
  WidgetOrAdvertisement: wrapEager(wrapCollectionLayout(WidgetOrAdvertisement)),
  MultipurposeComponent: wrapEager(wrapCollectionLayout(MultipurposeComponent)),
  FiveStories1AdWithWidget: wrapEager(wrapCollectionLayout(FiveStories1AdWithWidget)),
  NumberedNewsCard: wrapEager(wrapCollectionLayout(NumberedNewsCard)),
  Numbered5Stories: wrapEager(wrapCollectionLayout(Numbered5Stories)),
  FullScreenFeatured: wrapEager(wrapCollectionLayout(FullScreenFeatured)),
  TinyFourNewsCard: wrapEager(wrapCollectionLayout(TinyFourNewsCard)),
  VisualStories: wrapEager(wrapCollectionLayout(VisualStories)),
  NumberedSliderStories: wrapEager(wrapCollectionLayout(NumberedSliderStories)),
  OneSpecialStory3Related: wrapEager(wrapCollectionLayout(OneSpecialStory3Related)),
  NewsHeadlineTicker: wrapEager(wrapCollectionLayout(NewsHeadlineTicker)),
  TenNumberedStories: wrapEager(wrapCollectionLayout(TenNumberedStories)),
  defaultTemplate: wrapEager(wrapCollectionLayout(FourStories)),
};
